// extracted by mini-css-extract-plugin
module.exports = {"questionPage":"QuestionPage_questionPage__1blr7","questionTopicBg":"QuestionPage_questionTopicBg__2vSE9","mobileView":"QuestionPage_mobileView__2H-8y"};